import Actions from "../actions";
import { AlertType } from "../../app/Alertbar/AlertBar";
import { AlertAction, AlertDismissAction } from "./types";
import { AppThunkAction } from "..";
import { TK } from "../translations/translationKeys";
import { translate } from "../translations/hooks";

const alertsDuration = (nrChars: number) => 1000 + nrChars*40;

var alertNextId = 0;

export const alertDispatch = (type: AlertType, content: React.ReactNode, durationMs?: number, id?: string): AlertAction => ({
    type: Actions.Alert,
    payload: {
        id: id ?? (alertNextId++).toString(),
        type,
        content,
        durationMs,
    },
});

export const alertDismiss = (id: string): AlertDismissAction => ({
    type: Actions.AlertDismiss,
    payload: id,
});

export const alertGenericError = (): AppThunkAction<void> => {
    return (dispatch, getState) => {
        const msg = translate(TK.somethingWentWrong);
        dispatch(alertDispatch(AlertType.Error, msg, alertsDuration(msg.length)));
    };
}

export const alertError = (message: string, durationMs?: number, id?: string): AlertAction => 
    alertDispatch(AlertType.Error, message, durationMs ?? alertsDuration(message?.length ?? 0), id)

export const alertSuccess = (message: string, durationMs?: number): AlertAction => 
    alertDispatch(AlertType.Success, message, durationMs ?? alertsDuration(message?.length ?? 0))